// @ts-nocheck aaae9ac6
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_radiobutton'],
      sections: [addPanel.sections.getSections().developer.radioGroupSection],
    };
  },
};
